import { outter_post } from 'common/js/axios-helper';
import { ShopApi } from "./constant/UrlMapper";



const host = "9000";

//商品管理相关接口
const shopmanageList = (data) => {
    return outter_post(ShopApi.ShopManageList, data, host);
};
const shopmanageInsert = (data) => {
    return outter_post(ShopApi.ShopManageInsert, data, host);
};
const shopmanageEdit = (data) => {
    return outter_post(ShopApi.ShopManageEdit, data, host);
};
const shopmanageDel = (data) => {
    return outter_post(ShopApi.ShopManageDel, data, host);
};
const shopmanageStatus = (data) => {
    return outter_post(ShopApi.ShopManageStatus, data, host);
};
const shopmanageAddress = (data) => {
    return outter_post(ShopApi.ShopmanageAddress, data, host);
};

//订单查询相关接口
const orderqueryList = (data) => {
    return outter_post(ShopApi.OrderQueryList, data, host);
};
const orderqueryEdit = (data) => {
    return outter_post(ShopApi.OrderQueryEdit, data, host);
};
const orderqueryShenHe = (data) => {
    return outter_post(ShopApi.OrderQueryShenHe, data, host);
};
const orderqueryCreate = (data) => {
    return outter_post(ShopApi.OrderQueryCreate, data, host);
};
const orderqueryCreate3000 = (data) => {
    return outter_post(ShopApi.OrderQueryCreate3000, data, host);
};
const orderqueryLb = (data) => {
    return outter_post(ShopApi.OrderQueryLb, data, host);
};
const expressTypes = (data) => {
    return outter_post(MallApi.ExpressTypes, data, host);
};
const logisticsInfoList = (data) => {   //快递公司接口
    return outter_post(MallApi.LogisticsInfoList, data, host);
};
const topStatus = (data) => {
    return outter_post(ShopApi.TopStatus, data, host);
};
const shoppingList = (data) => {
    return outter_post(ShopApi.ShoppingList, data, host);
};


//商户商品管理相关接口
const apppointsshopmanageList = (data) => {
    return outter_post(ShopApi.AppPointsShopManageList, data, host);
};
const apppointsshopmanageInsert = (data) => {
    return outter_post(ShopApi.AppPointsShopManageInsert, data, host);
};
const apppointsshopmanageEdit = (data) => {
    return outter_post(ShopApi.AppPointsShopManageEdit, data, host);
};
const apppointsshopmanageDel = (data) => {
    return outter_post(ShopApi.AppPointsShopManageDel, data, host);
};
const apppointsshopmanageStatus = (data) => {
    return outter_post(ShopApi.AppPointsShopManageStatus, data, host);
};

//商户订单查询相关接口
const apppointsorderqueryList = (data) => {
    return outter_post(ShopApi.AppPointsOrderQueryList, data, host);
};
const apppointsorderqueryEdit = (data) => {
    return outter_post(ShopApi.AppPointsOrderQueryEdit, data, host);
};
const apppointsorderqueryShenHe = (data) => {
    return outter_post(ShopApi.AppPointsOrderQueryShenHe, data, host);
};

//支付方式相爱接口
const shoppaymentList = (data) => {
    return outter_post(ShopApi.ShopPaymentList, data, host);
};
const shoppaymentInsert = (data) => {
    return outter_post(ShopApi.ShopPaymentInsert, data, host);
};
const shoppaymentEdit = (data) => {
    return outter_post(ShopApi.ShopPaymentEdit, data, host);
};
const shoppaymentDel = (data) => {
    return outter_post(ShopApi.ShopPaymentDel, data, host);
};
const shoppaymentStatus = (data) => {
    return outter_post(ShopApi.ShopPaymentStatus, data, host);
};

//收款账号相关接口
const shopcollectionList = (data) => {
    return outter_post(ShopApi.ShopCollectionList, data, host);
};
const shopcollectionInsert = (data) => {
    return outter_post(ShopApi.ShopCollectionInsert, data, host);
};
const shopcollectionEdit = (data) => {
    return outter_post(ShopApi.ShopCollectionEdit, data, host);
};
const shopcollectionDel = (data) => {
    return outter_post(ShopApi.ShopCollectionDel, data, host);
};
const shopcollectionStatus = (data) => {
    return outter_post(ShopApi.ShopCollectionStatus, data, host);
};

//礼包配置接口
const giftpackmanageList = (data) => {
    return outter_post(ShopApi.GiftPackManageList, data, host);
};
const giftpackmanageEdit = (data) => {
    return outter_post(ShopApi.GiftPackManageEdit, data, host);
};
const giftpackmanageInsert = (data) => {
    return outter_post(ShopApi.GiftPackManageInsert, data, host);
};
const giftpackmanageDel = (data) => {
    return outter_post(ShopApi.GiftPackManageDel, data, host);
};

//代理商礼包
const giftpackagedetailsList = (data) => {
    return outter_post(ShopApi.GiftPackageDetailsList, data, host);
};
const gettargetAgentId = (data) => {
    return outter_post(ShopApi.GetTargetAgentId, data, host);
};
const giftpackagedetailsEdit = (data) => {
    return outter_post(ShopApi.GiftPackageDetailsEdit, data, host);
};

//礼包明细
const giftpackageinfoList = (data) => {
    return outter_post(ShopApi.GiftPackageInfoList, data, host);
};

const giftpackageput = (data) => {
    return outter_post(ShopApi.GiftPackagePut, data, host);
};

const gdPhoneLlist = (data) => {
    return outter_post(ShopApi.gdPhoneLlist, data, 8880);
};

const getFatherList = (data) => {
    return outter_post(ShopApi.seeFather, data, 9000);
};
export default {
    getFatherList,
    shopmanageList,
    shopmanageInsert,
    shopmanageEdit,
    shopmanageDel,
    shopmanageStatus,
    shopmanageAddress,

    orderqueryList,
    orderqueryEdit,
    orderqueryShenHe,
    orderqueryCreate,
    orderqueryCreate3000,
    orderqueryLb,
    expressTypes,
    logisticsInfoList,

    apppointsshopmanageList,
    apppointsshopmanageInsert,
    apppointsshopmanageEdit,
    apppointsshopmanageDel,
    apppointsshopmanageStatus,

    apppointsorderqueryList,
    apppointsorderqueryEdit,
    apppointsorderqueryShenHe,

    shoppaymentList,
    shoppaymentInsert,
    shoppaymentEdit,
    shoppaymentDel,
    shoppaymentStatus,
    topStatus,
    shoppingList,

    shopcollectionList,
    shopcollectionInsert,
    shopcollectionEdit,
    shopcollectionDel,
    shopcollectionStatus,

    giftpackmanageList,
    giftpackmanageEdit,
    giftpackmanageInsert,
    giftpackmanageDel,

    giftpackagedetailsList,
    gettargetAgentId,
    giftpackagedetailsEdit,

    giftpackageinfoList,

    giftpackageput,
    gdPhoneLlist,
}



// WEBPACK FOOTER //
// ./src/service/ShopService.js